module.exports = function () {
  return {
    $get: ['$ionicPopup', '$timeout', '$translate',
      function ($ionicPopup, $timeout, $translate) {
        /*
                 * function: alertPopup 弹出提示窗口
                 * @param title  标题栏内容
                 * @param content  内容
                 * Created by kpzeng
                 */
        function alertPopup(title, content) {
          return $ionicPopup.alert({
            title: title,
            template: content
          })
        }

        /*
                 * function:
                 * @param
                 * Created by kpzeng
                 */
        function confirmPopup(title, content, options = {}) {
          const okText = !options.reverseBtnOrder ? $translate.instant('OP.OK') : $translate.instant('OP.CANCEL')
          const cancelText = !options.reverseBtnOrder ? $translate.instant('OP.CANCEL') : $translate.instant('OP.OK')
          const okType = !options.highlightCancel ? 'button-default' : 'button-positive'
          const cancelType = !options.highlightCancel ? 'button-positive' : 'button-default'
          const params = {
            okText: options.okText || okText,
            cancelText: options.cancelText || cancelText,
            okType: options.okType || okType,
            cancelType: options.cancelType || cancelType,
          }
          return $ionicPopup.confirm({
            title: title,
            template: content,
            ...params
          })
        }
        /*
                 * function: promptPopup
                 * @param @options
                 * @param title 弹出框的标题 Optional
                 * @param tempalte 弹出框的提示信息模板 Optional
                 * @param inputType 输入框的类型 默认text，可选password等 Optional
                 * @param inputPlaceholder 输入框的提示文字  Optional
                 * reeturn promise 对象 包含输入的信息
                 * Created by kpzeng
                 */
        function promptPopup(options) {
          const title = options.title ? options.title : '系统消息'
          const template = options.template ? options.template : ''
          const inputType = options.inputType ? options.inputType : 'text'
          const inputPlaceholder = options.inputPlaceholder ? options.inputPlaceholder : ''
          return $ionicPopup.prompt({
            title: title,
            template: template,
            inputType: inputType,
            inputPlaceholder: inputPlaceholder
          })
        }

        const showWarning = function (content) {
          const warning = $ionicPopup.show({
            template: '<p style="text-align: center">' + content + '</p>'
          })
          $timeout(function () {
            warning.close()
          }, 2000)
        }

        const showSelect = function (title, content, text1, text2, func1, func2) {
          $ionicPopup.show({
            title: title || '注意',
            template: '<p style="text-align: center">' + content + '</p>',
            buttons: [{
              text: text1,
              type: 'button-default',
              onTap: func1()
            }, {
              text: text2,
              type: 'button-positive',
              onTap: func2()
            }]
          })
        }

        return {
          alertPopup: alertPopup,
          confirmPopup: confirmPopup,
          promptPopup: promptPopup,
          showWarning: showWarning,
          showSelect: showSelect
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/popUp.js